import Loadable from 'components/Loadable';
import { NOT_FOUND_PATH, NO_PERMISSION_PATH, ROOT } from 'constant/path';
import { lazy } from 'react';
const NotFound = Loadable(lazy(() => import('views/pages/NotFound')));
const NoPermission = Loadable(lazy(() => import('views/pages/NoPermission')));

const NotFoundRoute = {
  path: NOT_FOUND_PATH,
  element: <NotFound />,
  children: [],
};

const NoPermissionRoute = {
  path: `${ROOT}${NO_PERMISSION_PATH}`,
  element: <NoPermission />,
  children: [],
};

const NoAuthenticationRoutes = {
  NotFoundRoute,
  NoPermissionRoute,
};

export default NoAuthenticationRoutes;
